export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/combination-check.f54dae09-e12319.svg";